import { Divider, Skeleton } from 'antd';

/**
 * 与 OrderCard 布局一致的骨架屏，用于订单加载状态
 */
export const OrderSkeleton = () => {
  return (
    <div className="px-4 bg-[var(--fett-bg-elevated)]">
      {/* OrderStatus 区域：标题 + 副行 + 按钮 */}
      <div className="py-4">
        <div className="flex items-center justify-between">
          <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
        </div>
        <div className="mt-1 flex items-center justify-between gap-2">
          <Skeleton.Input active size="small" className="!w-24 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-32 !min-w-0" />
        </div>
      </div>
      <Divider className="!my-0" />

      {/* OrderProductList 区域：首条商品 + 更多行 */}
      <div className="py-3 flex flex-col">
        <div className="h-[48px] flex gap-2 items-start">
          <Skeleton.Avatar active shape="square" size={48} className="!rounded-[2px] !w-12 !h-12" />
          <div className="flex-1 min-w-0 space-y-2">
            <div className="flex justify-between items-center gap-2">
              <Skeleton.Input active size="small" className="!flex-1 !min-w-0" />
              <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
            </div>
            <div className="flex justify-between items-center gap-2">
              <div className="flex gap-2">
                <Skeleton.Input active size="small" className="!w-8 !min-w-0" />
                <Skeleton.Input active size="small" className="!w-12 !min-w-0" />
              </div>
              <Skeleton.Input active size="small" className="!w-6 !min-w-0" />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-3 gap-2">
          <Skeleton.Input active size="small" className="!w-12 !min-w-0" />
          <div className="flex items-center gap-1">
            <Skeleton.Input active size="small" className="!w-14 !min-w-0" />
            <Skeleton.Input active size="small" className="!w-16 !min-w-0" />
          </div>
        </div>
      </div>
      <Divider className="!my-0" />

      {/* 底部 OrderRow：物流方式、物流单号 */}
      <div className="flex flex-col py-3 gap-3">
        <div className="flex items-start justify-between gap-2">
          <Skeleton.Input active size="small" className="!w-14 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-12 !min-w-0" />
        </div>
        <div className="flex items-start justify-between gap-2">
          <Skeleton.Input active size="small" className="!w-20 !min-w-0" />
          <Skeleton.Input active size="small" className="!w-24 !min-w-0" />
        </div>
      </div>
    </div>
  );
};
